import React from 'react';
import { useAudioAnalysis } from '../contexts/AudioAnalysisContext';
import { getCurrentHost, HOSTS } from '../utils/hostConfig';

const BackgroundAnalysisIndicator = () => {
  const { pendingAnalysis, isAnalyzing, uploadProgress, cancelAnalysis } = useAudioAnalysis();

  if (!isAnalyzing) return null;

  const getStatusText = () => {
    if (pendingAnalysis?.status === 'uploading') {
      return `업로드 중... ${uploadProgress}%`;
    }
    return '음성 분석 중...';
  };

  // Get the correct URL for audio analysis page
  const getAudioAnalysisUrl = () => {
    const currentHost = getCurrentHost();
    // If already on AI subdomain, use relative path
    if (currentHost === HOSTS.AI) {
      return '/audio-analysis';
    }
    // Otherwise, redirect to AI subdomain
    const isProduction = window.location.hostname.includes('ilouli.com');
    if (isProduction) {
      return 'https://ai.ilouli.com/audio-analysis';
    }
    // Local development - use query param
    return '/?host=ai#/audio-analysis';
  };

  const handleViewClick = () => {
    const url = getAudioAnalysisUrl();
    if (url.startsWith('http') || url.startsWith('/?')) {
      window.location.href = url;
    } else {
      window.location.href = url;
    }
  };

  return (
    <div className="fixed bottom-5 right-5 z-[1000] bg-gradient-to-br from-blue-800 to-blue-500 text-white py-3 px-4 rounded-xl shadow-[0_4px_20px_rgba(59,130,246,0.4)] animate-[slideIn_0.3s_ease-out] max-sm:bottom-[70px] max-sm:right-2.5 max-sm:left-2.5 max-sm:py-2 max-sm:px-3">
      <div className="flex items-center gap-3">
        <span className="w-[18px] h-[18px] border-2 border-white/30 border-t-white rounded-full animate-spin"></span>
        <div className="flex flex-col gap-0.5 max-w-[200px] max-sm:max-w-none max-sm:flex-1">
          <span className="text-sm font-semibold">{getStatusText()}</span>
          <span className="text-[11px] opacity-80 whitespace-nowrap overflow-hidden text-ellipsis">{pendingAnalysis?.fileName}</span>
        </div>
        <div className="flex items-center gap-2 ml-2">
          <button
            onClick={handleViewClick}
            className="py-1 px-2.5 bg-white/20 text-white no-underline text-xs font-medium rounded transition-colors duration-200 hover:bg-white/30"
          >
            보기
          </button>
          <button
            className="w-6 h-6 flex items-center justify-center bg-transparent border border-white/30 text-white text-sm rounded-full cursor-pointer transition-all duration-200 p-0 hover:bg-white/20 hover:border-white/50"
            onClick={cancelAnalysis}
            title="분석 취소"
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
};

export default BackgroundAnalysisIndicator;
